import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, FormattedMessage} from 'react-intl';
import {getSelectedFragnents, getSelectedFromUrl, ApplicationObserver} from '../web/SelectWidget.react';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import NoScenariosMail from '../web/noScenariosMail.react';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import diff from 'deep-diff';
import * as Tool from '../fw/Tool';

class ChannelDefDetailScenarios extends React.Component {
	static propTypes = {
		intl: PropTypes.object,
		relay: PropTypes.object,
		user: PropTypes.object.isRequired,
	};


	componentDidMount() {
		let loadingEl = document.querySelector('#relayLoading');

		if (loadingEl) {
			loadingEl.remove();
		}

		LoadingLine.stop();

		this.applicationObserver = (applications) => {
			this.onApplicationChange(applications);
		};

		ApplicationObserver.subscribe(this.applicationObserver);
	}

	componentDidUpdate(prevProps) {
		if (diff(prevProps.user, this.props.user)) {
			LoadingLine.stop();
		}
	}

	componentWillUnmount() {
		ApplicationObserver.unsubscribe(this.applicationObserver);
	}

	onApplicationChange(applications) {
		LoadingLine.start();

		this.props.relay.setVariables({
			channelDefUrlFragments: applications.map(app => app.urlFragment)
		});
	}

	getChannelDef() {
		return this.props.user.channelDefs.edges[0].node;
	}

	hasNoScenarions() {
		let channelDef = this.getChannelDef();

		return (!channelDef.destinationScenarios || channelDef.destinationScenarios.edges.length === 0)
			&& (!channelDef.integratedScenarios || channelDef.integratedScenarios.edges.length === 0)
			&& (!channelDef.helpingScenarios || channelDef.helpingScenarios.edges.length === 0);
	}

	render() {
		let channelDef = this.getChannelDef();
		let metadata = types['channelDefs'];

		let {
			name,
		} = Tool.getDataForColumns(['name', 'description', 'longDescription'], metadata.fields(), channelDef);

		return (
			<div>
				<LoadingLine />

				{channelDef.destinationScenarios && channelDef.destinationScenarios.edges.length > 0 ?
					<div>
						<h3 id="destinationScenarios"><FormattedMessage defaultMessage="Integration scenarios displayed in {application}:" id="channel.destinationScenariosHeader" values={{application: name}} /></h3>
						<div className="scenarioGridList">
							{channelDef.destinationScenarios.edges.map(({node}, idx) => {
								return (
									<ScenarioBox key={idx} metadata={types['scenarios']} scenario={node} urlMapping={urlMapping}/>
								);
							})}
						</div>
					</div>
				: null }

				{channelDef.integratedScenarios && channelDef.integratedScenarios.edges.length > 0 ?
					<div>
						<h3 id="integratedScenarios"><FormattedMessage defaultMessage="Integration scenarios with data from {application}:" id="channel.integratedScenariosHeader" values={{application: name}} /></h3>
						<div className="scenarioGridList">
							{channelDef.integratedScenarios.edges.map(({node}, idx) => {
								return (
									<ScenarioBox key={idx} metadata={types['scenarios']} scenario={node} urlMapping={urlMapping}/>
								);
							})}
						</div>
					</div>
				: null }

				{channelDef.helpingScenarios && channelDef.helpingScenarios.edges.length > 0 ?
					<div>
						<h3 id="helpingScenarios"><FormattedMessage defaultMessage="Integration scenarios with help of {application}:" id="channel.helpingScenariosHeader" values={{application: name}} /></h3>
						<div className="scenarioGridList">
							{channelDef.helpingScenarios.edges.map(({node}, idx) => {
								return (
									<ScenarioBox key={idx} metadata={types['scenarios']} scenario={node} urlMapping={urlMapping}/>
								);
							})}
						</div>
					</div>
				: null }

				{this.hasNoScenarions() ? <NoScenariosMail selectedApplications={[this.getChannelDef(), ...getSelectedFromUrl()]} /> : null}
			</div>
		);
	}
}


export default Relay.createContainer(injectIntl(ChannelDefDetailScenarios), {
	initialVariables: {
		channelDefUrlFragment: '',
		channelDefUrlFragments: null,
		relevantScenariosCnt: 0
	},
	prepareVariables (variables) {
		variables.channelDefUrlFragments = getSelectedFragnents();

		if (document.location.pathname.split('/').length > 3) {
			variables.channelDefUrlFragment = document.location.pathname.split('/')[3];
		}

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				channelDefs: publicChannelDefs(first: 1, urlFragment: $channelDefUrlFragment) {
					edges {
						node {
							id,
							realId,
							name,
							integratedScenarios : relevantScenarios(first: 1000, ruleType: "integrated", channelDefUrlFragments: $channelDefUrlFragments) {
								edges {
									node {
										id,
										realId,
										state,
										visibility,
										channelState,
										${ScenarioBox.getFragment('scenario')}
									}
								}
							},
							destinationScenarios : relevantScenarios(first: 1000, ruleType: "destination", channelDefUrlFragments: $channelDefUrlFragments) {
								edges {
									node {
										id,
										realId,
										state,
										visibility,
										channelState,
										${ScenarioBox.getFragment('scenario')}
									}
								}
							},
							helpingScenarios : relevantScenarios(first: 1000, ruleType: "helping", channelDefUrlFragments: $channelDefUrlFragments) {
								edges {
									node {
										id,
										realId,
										state,
										visibility,
										channelState,
										${ScenarioBox.getFragment('scenario')}
									}
								}
							},
						}
					}
				}
			}
		`,
	},
});
